<template>
  <div class="align-items-center login">
    <div>
      <b-navbar
        type="dark"
        class="nav-up"
        toggleable="md"
        style="height: 35px"
      ></b-navbar>
      <b-navbar toggleable="md" class="nav-down" style="height: 40px">
        <img
          src="/images/logo1.svg"
          style="height: 290px"
          alt="FGA"
          class="center"
        />
      </b-navbar>
    </div>
    <div>
      <b-img src="/images/FONDOS.jpg" fluid class="img-titulo"></b-img>
      <h4 class="texto-titulo">Portal intermediarios financieros</h4>
    </div>
    <div id="login-view" class="container bt-3">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card no-body>
            <b-card-body style="padding: 3rem 3rem 0rem 3rem !important">
              <b-form @submit.prevent="onLogin">
                <h3>Autenticación</h3>
                <p class="text-muted mb-5">Ingrese su usuario y contraseña</p>

                <b-form-group
                  label="Usuario"
                  label-for="usuario"
                  :label-cols="4"
                  :label-md="3"
                >
                  <b-form-input
                    id="usuario"
                    type="text"
                    v-model="usuario"
                    required
                  ></b-form-input>
                  <!-- control de errores -->
                  <span
                    v-if="errors ? errors.usuario : ''"
                    :class="['text-danger']"
                    >{{ errors.usuario[0] }}</span
                  >
                </b-form-group>

                <b-form-group
                  label="Contraseña"
                  label-for="password"
                  :label-cols="4"
                  :label-md="3"
                >
                  <b-form-input
                    id="password"
                    type="password"
                    v-model="password"
                    autocomplete="password"
                    required
                  ></b-form-input>
                  <!-- control de errores -->
                  <span
                    v-if="errors ? errors.password : ''"
                    :class="['text-danger']"
                    >{{ errors.password[0] }}</span
                  >
                </b-form-group>

                <b-row>
                  <b-col cols="12" class="text-right olvido">
                    ¿No recuerda su contraseña?
                    <b-button variant="link" v-b-modal.modal-Recuperar-password
                      >Clic aquí</b-button
                    >
                  </b-col>
                  <b-col cols="12" class="text-right pb-5 mb-2">
                    <img
                      v-if="loading"
                      class="loading"
                      src="@/assets/images/loader.gif"
                      alt
                    />
                    <b-button
                      variant="outline-primary"
                      class="px-4 mt-2"
                      :disabled="loading"
                      type="submit"
                      >Ingresar</b-button
                    >
                  </b-col>
                </b-row>
              </b-form>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <div class="foot-login">
      <!-- Ultima linea -->
      <b-row class="foot">
        <b-col cols="12" md="8" class="mb-2 ml-4 text-left">
          <div class="mb-3 ml-5">
            &nbsp;
            <br />FGA - Todos los derechos reservados
          </div>
        </b-col>
        <b-col cols="12" md="3" class="mb-2">
          <div>
            &nbsp;
            <br />Visite nuestras redes
            <a
              href="https://www.linkedin.com/company/fga-fondo-de-garantias"
              class="m-3"
              target="_blank"
              data-toggle="tooltip"
              title="LinkedIn"
            >
              <i class="fa fa-linkedin fa-2x"></i>
            </a>
            <a
              href="https://www.instagram.com/fgafondodegarantias/"
              target="_blank"
              data-toggle="tooltip"
              title="Instragram"
            >
              <i class="fa fa-instagram fa-2x"></i>
            </a>
            <a
              href="https://www.facebook.com/FGAFondodeGarantias"
              class="m-3"
              target="_blank"
              data-toggle="tooltip"
              title="Facebook"
            >
              <i class="fa fa-facebook fa-2x"></i>
            </a>
            <a
              href="https://www.youtube.com/user/FGAFondoGarantias"
              target="_blank"
              data-toggle="tooltip"
              title="YouTube"
            >
              <i class="fa fa-youtube-play fa-2x"></i>
            </a>
          </div>
        </b-col>
      </b-row>
    </div>

    <!-- Modal de olvide la contraseña -->
    <b-modal
      id="modal-Recuperar-password"
      title="Recuperar Contraseña"
      ref="modal-Recuperar-password"
      hide-footer
      size="xl"
    >
      <div class="rec-pass">
        <div>
          <h3 class="color-secundary">Recuperacion de contraseña</h3>
          <p class="mb-4 text-justify">
            Para recuperar su contraseña debe digitar el usuario con el que se
            encuentra registrado, el sistema automáticamente le enviara un
            correo electrónico con los pasos a seguir.
          </p>
        </div>
        <br />
        <b-form-group label="Usuario" label-for="usuarioModal" :label-cols="3">
          <b-form-input
            id="usuarioModal"
            type="text"
            v-model="usuarioModal"
          ></b-form-input>
        </b-form-group>

        <div class="text-right">
          <img
            v-if="loading"
            class="loading"
            src="@/assets/images/loader.gif"
            alt
          />
          <b-button
            variant="outline-primary"
            style="margin-right: 2%"
            @click="borrar"
            >Borrar</b-button
          >
          <b-button
            variant="outline-primary"
            @click="enviarCorreo"
            :disabled="loading"
            >Recuperar</b-button
          >
        </div>
      </div>
    </b-modal>

    <b-modal
        id="modal-codigo-mfa"
        ref="modal-codigo-mfa"
        title="Código de seguridad"
        size="lg"
        hide-footer
      >
        <div class="rec-pass">
        <div>
          <p class="mb-4 text-justify">
            Por favor ingrese el código de seguridad para continuar.
          </p>
        </div>
        <br />
        <b-form-group label="Código" label-for="codigo" :label-cols="2">
          <b-form-input
            id="codigo"
            type="text"
            v-model="codigo"
          ></b-form-input>
          <p style="color: red;" v-if="error_message != ''">{{error_message}}</p>
        </b-form-group>

        <div class="text-right">
          <img
            v-if="loading"
            class="loading"
            src="@/assets/images/loader.gif"
            alt
          />
          <b-button variant="outline-primary" @click="onLogin" :disabled="loading"
            >Enviar</b-button
          >
        </div>
      </div>
      </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { debuglog } from "util";

export default {
  name: "Login",
  components: {},
  // errors: {usuario:["El campo usuario es obligatorio."], password:["El campo contraseña es obligatorio"]}
  data() {
    return {
      usuario: "",
      password: "",
      errors: {},
      usuarioModal: "",
      codigo: "",
      error_message: ""
    };
  },
  computed: {
    loading() {
      return this.$store.getters["user/auth_request"];
    },
    ...mapGetters({
      api: "apiSig",
      echo: "echo",
    }),
  },
  methods: {
    onLogin() {
      this.error_message = '';
      let _codigo = this.codigo == "" || this.codigo === null ? false: this.codigo;
      this.$store
        .dispatch("user/login", {
          username: this.usuario,
          password: this.password,
          codigo: _codigo
        })
        .then((response) => {
          console.log(response, 'here');
          this.$router.replace({ path: "/home" });
        })
        .catch((error) => {
          this.errors = error.response.data.error;
          this.codigo = "";
          this.error_message = "";
          switch (this.errors) {
            case "require_code":
              this.$refs['modal-codigo-mfa'].show();
              break;
            case "Unauthorized":
              this.$refs['modal-codigo-mfa'].hide();
              let toast = this.$toasted.show(
                "Usuario y/o contraseña inválidos",
                {
                  theme: "toasted-primary",
                  position: "top-right",
                  duration: 5000,
                }
              );
              break;
            case "locked":
              this.$refs['modal-codigo-mfa'].hide();
              let toast2 = this.$toasted.show("Usuario bloqueado", {
                theme: "toasted-primary",
                position: "top-right",
                duration: 5000,
              });
              break;
            case "Unauthorized Code":
              let toast3 = this.$toasted.show("Código incorrecto", {
                theme: "toasted-primary",
                position: "top-right",
                duration: 5000,
              });
              this.error_message = "El código ingresado es incorrecto.";
              break;
          } //extractError(error);
        });
    },
    onReset(evt) {
      (this.usuario = ""), (this.password = ""), (this.confirmar = "");
    },
    borrar() {
      this.usuarioModal = "";
    },
    enviarCorreo() {
      if (this.usuarioModal) {
        this.$store
          .dispatch("user/recuperarpassword", {
            username: this.usuarioModal,
          })
          .then((response) => {
            this.$refs["modal-Recuperar-password"].hide();
            let toast3 = this.$toasted.show(
              "se envio correo con contraseña temporal",
              {
                theme: "toasted-primary",
                position: "top-right",
                duration: 5000,
              }
            );
          })
          .catch((error) => {
            this.errors = error.response.data.error;
            let toast = this.$toasted.show("Usuario no registrado", {
              theme: "toasted-primary",
              position: "top-right",
              duration: 5000,
            });
          });
      }
    },
  },
};
</script>
<style lang="scss">
.loading {
  padding: 7px;
  margin-top: 4px;
}
</style>